import React, { useState, useRef } from 'react';
import { Star } from 'lucide-react';
import { motion } from 'framer-motion';
const testimonials = [{
  quote: 'Compré un domingo a la noche. El lunes entré a la clase de prácticas con el plan exacto del entrenamiento. El Tomo 1 es exactamente lo que necesitaba para organizar toda mi carrera. Nunca más improviso.',
  name: 'Sofía M.',
  role: 'Estudiante del Profesorado de EF',
  location: '📍 Buenos Aires'
}, {
  quote: 'El Tomo 2, el de Anatomía y Fisiología, me cambió todo. El primer mes, aprobé dos materias que había llevado a diciembre el año anterior. Las guías visuales me dan la claridad que antes no tenía.',
  name: 'Lucas R.',
  role: 'Estudiante de 2do año',
  location: '📍 Rosario'
}, {
  quote: 'El sistema de plantillas es único en el mercado. 50+ recursos listos para usar con diagramas, criterios y variantes por nivel. Antes tardaba horas armando una planificación. Ahora abro el PDF y en 10 minutos tengo todo listo.',
  name: 'Valentina F.',
  role: 'Estudiante en Prácticas Docentes',
  location: '📍 Córdoba'
}, {
  quote: 'Las rúbricas del Tomo 5 eliminaron mi inseguridad al evaluar. Ahora sé exactamente cómo calificar a cada alumno y puedo fundamentarlo frente al docente de cátedra. Mis entregas tienen otro nivel de profesionalismo.',
  name: 'Luciana P.',
  role: 'Estudiante de 3er año',
  location: '📍 Tucumán'
}, {
  quote: 'La tasa de materias que llevo a diciembre bajó a cero. Sin cambiar lo que estudio. Solo aplicando el sistema de organización y los simulacros de parcial del kit. Ahora sé exactamente qué repasar antes de cada evaluación.',
  name: 'Marcela G.',
  role: 'Estudiante del Profesorado',
  location: '📍 Mendoza'
}, {
  quote: 'El Bono 6 de simulacros me salvó de entrar al oral sin saber cómo estructurar las respuestas. Ahora tengo un sistema para estudiar que funciona y apruebo con notas que antes no sacaba.',
  name: 'Laura V.',
  role: 'Estudiante de 4to año',
  location: '📍 Santa Fe'
}, {
  quote: 'El Kit Completo Élite me cambió la cabeza. Nunca había dimensionado el potencial de tener todo el material organizado en un solo lugar. Ahora estudio con una seguridad que antes no tenía y rindo con confianza real.',
  name: 'Ana R.',
  role: 'Estudiante del Profesorado de EF',
  location: '📍 Salta'
}];
export function LongTestimonials() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const handleScroll = () => {
    if (!scrollRef.current) return;
    const {
      scrollLeft,
      scrollWidth
    } = scrollRef.current;
    const itemWidth = scrollWidth / testimonials.length;
    setActiveIndex(Math.round(scrollLeft / itemWidth));
  };
  return <section className="py-10 md:py-16 bg-white overflow-hidden" data-id="element-185">
      <div className="max-w-6xl mx-auto px-4" data-id="element-186">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8 md:mb-12" data-id="element-187">
          <h2 className="text-2xl md:text-4xl font-black text-brand-950 mb-3 md:mb-4" data-id="element-188">
            Lo que dicen los estudiantes que ya lo usan:
          </h2>
          <p className="text-xs md:text-xl text-brand-600 font-bold bg-brand-50 inline-block px-4 py-1.5 md:px-6 md:py-2 rounded-full" data-id="element-189">
            +500 estudiantes del Profesorado de EF de todo el país ya tienen su
            Profesorado Resuelto™
          </p>
        </motion.div>

        {/* Mobile Carousel */}
        <div className="md:hidden mb-4" data-id="element-190">
          <div ref={scrollRef} onScroll={handleScroll} className="flex overflow-x-auto snap-x snap-mandatory hide-scrollbar gap-3 pb-4 -mx-4 px-4" data-id="element-191">
            {testimonials.map((t, i) => <div key={i} className="min-w-[85%] snap-center bg-gray-50 rounded-xl p-4 border border-gray-100 shadow-sm flex flex-col" data-id="element-192">
                <div className="flex gap-1 mb-3" data-id="element-193">
                  {[...Array(5)].map((_, j) => <Star key={j} className="w-3.5 h-3.5 text-yellow-400 fill-yellow-400" data-id="element-194" />)}
                </div>
                <p className="text-gray-700 italic mb-4 text-xs leading-relaxed flex-grow" data-id="element-195">
                  "{t.quote}"
                </p>
                <div className="border-t border-gray-200 pt-3 mt-auto" data-id="element-196">
                  <p className="font-bold text-brand-900 text-xs" data-id="element-197">{t.name}</p>
                  <p className="text-[10px] text-gray-500 mt-0.5" data-id="element-198">{t.role}</p>
                  <p className="text-[10px] font-medium text-brand-600 mt-1" data-id="element-199">
                    {t.location}
                  </p>
                </div>
              </div>)}
          </div>
          <div className="flex justify-center gap-1.5 mt-1" data-id="element-200">
            {testimonials.map((_, i) => <div key={i} className={`h-1.5 rounded-full transition-all duration-300 ${i === activeIndex ? 'w-4 bg-brand-600' : 'w-1.5 bg-gray-300'}`} data-id="element-201" />)}
          </div>
        </div>

        {/* Desktop Columns */}
        <div className="hidden md:columns-2 lg:columns-3 gap-6 space-y-6" data-id="element-202">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="break-inside-avoid bg-gray-50 rounded-2xl p-6 border border-gray-100 shadow-sm hover:shadow-md transition-shadow" data-id="element-203">
              <div className="flex gap-1 mb-4" data-id="element-204">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 text-yellow-400 fill-yellow-400" data-id="element-205" />)}
              </div>
              <p className="text-gray-700 italic mb-6 text-sm leading-relaxed" data-id="element-206">
                "{t.quote}"
              </p>
              <div className="border-t border-gray-200 pt-4" data-id="element-207">
                <p className="font-bold text-brand-900 text-sm" data-id="element-208">{t.name}</p>
                <p className="text-xs text-gray-500 mt-0.5" data-id="element-209">{t.role}</p>
                <p className="text-xs font-medium text-brand-600 mt-1" data-id="element-210">
                  {t.location}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}